export default "__VITE_ASSET__DjFMturw__"